import React from 'react';
import { motion } from 'framer-motion';
import { PricingSelector } from './PricingSelector';
import { UrgencyBanner } from './UrgencyBanner';
export const FinalCTA = () => {
  return <section className="py-16 md:py-24 bg-navy relative text-cream overflow-hidden" data-id="element-73">
      <div className="absolute inset-0 bg-noise opacity-20 pointer-events-none" data-id="element-74"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-75"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center mb-8" data-id="element-77">
          <div className="text-gold-500 text-2xl mb-3" data-id="element-78">✦ ❦ ✦</div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-balance" data-id="element-79">
            LA MEMORIA DEL ALMA™
          </h2>
          <p className="text-base md:text-xl text-cream-200/80 leading-relaxed font-serif italic" data-id="element-80">
            Tu última oportunidad de acceder al precio de lanzamiento.
          </p>
        </motion.div>

        <UrgencyBanner variant="dark" data-id="element-81" />

        <PricingSelector variant="dark" data-id="element-82" />
      </div>
    </section>;
};